angular.module('olivioConfiguratorApp')
  .controller('DetailsCtrl', function ($scope, Model, Data, StepService, $timeout) {
    //console.log('init DetailsCtrl');
    /**@const{Boolean}*/ var goboAllowed = Model.goboAllowed();

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;

    OLIVIO.cmodel.initFromAngularModel(Model.model, Data);
    OLIVIO.cmodel.setSingleLumSelected(-1); // sets pub.firstAndLastLumSelected = false;


    $scope.currentDistributionOptions = [];
    $scope.currentPowerOptions = [];

    var calculateDistributionOptions = function () {
      for (var i = 0; i < $scope.model.design.lumcount; i++) {
        $scope.currentDistributionOptions[i] = $scope.data.findIndividualDistributionOptions($scope.model, i);
        var currentOptionID = $scope.model.distribution.individual[i];
        if ($scope.currentDistributionOptions[i].indexOf(currentOptionID) <0) { // Noch sind ids im array
          // falls nicht verfügbar ...erste verfügbare Option wählen.
          $scope.model.distribution.individual[i] = $scope.currentDistributionOptions[i][0];
        }
        // volle optionen holen, wie vom html erwartet
        for(var j = 0; j<$scope.currentDistributionOptions[i].length; j++) {
          $scope.currentDistributionOptions[i][j] = $scope.data.getDistributionOption($scope.currentDistributionOptions[i][j]);
        }
      }
      console.log('calculated Distribution options', $scope.currentDistributionOptions);
    };

    var calculatePowerOptions = function () {
      for (var i = 0; i < $scope.model.design.lumcount; i++) {
        $scope.currentPowerOptions[i] = $scope.data.findIndividualPowerOptions($scope.model, i);
        var currentOptionID = $scope.model.power.individual[i];
        if ($scope.currentPowerOptions[i].indexOf(currentOptionID) <0) { // Noch sind ids im array
          // falls nicht verfügbar ...erste verfügbare Option wählen.
          $scope.model.power.individual[i] = $scope.currentPowerOptions[i][0];
        }
        // volle optionen holen, wie vom html erwartet
        for(var j = 0; j<$scope.currentPowerOptions[i].length; j++) {
          $scope.currentPowerOptions[i][j] = $scope.data.getPowerOption($scope.currentPowerOptions[i][j]);
        }
      }
      console.log('calculated Power options', $scope.currentPowerOptions);
    };


    //ie9 select list workaround
    $scope.fixIE = function () {
      //code to check if IE so the other browsers don't get this ugly hack.
      var selectLists = document.querySelectorAll('.detailsselect');
      for (var x = 0; x < selectLists.length; x++) {
        var select = selectLists[x];
        for (var y = 0; y < select.length; y++) {
          if (select[y].text[select[y].text.length - 1] === ' ') {
            select[y].text = select[y].text.slice(0, -1);
          } else {
            select[y].text += ' ';
          }
        }
      }
    };

    (function () {  // init
      calculateDistributionOptions();
      calculatePowerOptions();

      // check conditions
      Data.applyConstraints($scope.model);
      $scope.model.details.done = true;
      StepService.updateEnabled();
    })();

    $timeout(function () {
      $scope.$eval($scope.fixIE());
    });

    $scope.recalculateHeads = function (index) {
      if($scope.individualHeads[index] === 'gobo') {
        $scope.model.design.goboDone = true;
        $scope.model.gobo.done = true; // wir stellen hier ja etwas ein und zeigen das dem Anwender, daher darf auch der Schritt als erledigt gelten
        $scope.model.gobo.individual[index] = true;
        if(!$scope.model.gobo.id || $scope.model.gobo.id === '')
          $scope.model.gobo.id = $scope.data.goboOptions[2].id; // the default gobo if gobo step got skipped before, 2 is 'standard'
        $scope.model.gobo.individualType[index] = $scope.model.gobo.id;
        StepService.getStep('gobo').skipped = false;
      } else {
        $scope.model.gobo.individual[index] = false;
        $scope.model.design.individualHeads[index] = $scope.individualHeads[index];
        StepService.getStep('gobo').skipped = !Model.haveGobo();
      }
      StepService.updateEnabled();
      // console.log('recalculateHeads', index, $scope.individualHeads[index], $scope.model.gobo.individual[index], $scope.model.design.individualHeads[index]);
    };

    $scope.recalculate = function () {
      if($scope.model.assembly.id === 'led' && $scope.model.color.id === 'rgbw' && $scope.model.distribution.id === 'asymetric') {
        $scope.model.distribution.id === 'symetric';
      }
      Data.applyDistributionConstraints($scope.model);
      $scope.$safeApply($scope, function () {
        calculateDistributionOptions();
        calculatePowerOptions();
      });
    };


    if(goboAllowed) {
      $scope.lumOptions = Data.lumOptions.slice();
      $scope.lumOptions.push({
        id: 'gobo',
        name: 'Gobo  Ø 205',
        disabled: false
      });
    } else {
      $scope.lumOptions = Data.lumOptions;
    }
    // console.log('details init: goboAllowed '+goboAllowed, Data.lumOptions.slice(), ' => ', $scope.lumOptions);

    // get range for ngRepeat
    $scope.lumRange = function () {
      if(goboAllowed) {
        $scope.individualHeads = new Array($scope.model.design.lumcount);
        for(var i=$scope.individualHeads.length-1;i>=0;i--) {
          $scope.individualHeads[i] = $scope.model.gobo.individual[i] ?
            'gobo' :
            $scope.model.design.individualHeads[i];
        }
      } else {
        $scope.individualHeads = $scope.model.design.individualHeads;
      }
      return $scope.individualHeads;
    };

    $scope.setGoboDefault = function(index) {
      $scope.model.gobo.id = $scope.model.gobo.individualType[index];
    };

    // in der Schrittunterschrift stehen dann eventuell verbotene Kombinationen. man müsste auch die defaults der abhängigen Daten ändern, insb. power wenn sich distribution oder kopfgröße ändern
    // zweitens werden die hier veränderten defaults nicht genutzt, wenn von gobo auf den regulären kopf zurückgeschaltet wird.
    //$scope.setDistributionDefault = function(index) {
    //  //$scope.model.distribution.id = $scope.model.distribution.individual[index];
    //};
    //
    //$scope.setColorDefault = function(index) {
    //  //$scope.model.color.id = $scope.model.color.individual[$index];
    //};
    //
    //$scope.setPowerDefault = function(index) {
    //  //model.power.id =model.power.individual[$index];
    //};

  });

